import {
  DATASET_ROLE_ANNOTATOR,
  DATASET_ROLE_CONSUMER,
  DATASET_ROLE_CONTRIBUTOR,
  DATASET_ROLE_OWNER,
  DATASET_ROLE_RESTRICTED_CONSUMER,
} from '../../constants/index.js';

import type { DatasetRoleName } from './hasDatasetRole.interface.js';

const DATASET_ROLE_HIERARCHY = [
  [DATASET_ROLE_OWNER],
  [DATASET_ROLE_CONTRIBUTOR],
  [DATASET_ROLE_ANNOTATOR],
  [DATASET_ROLE_CONSUMER, DATASET_ROLE_RESTRICTED_CONSUMER],
] as const;

function getRoleLevel(role: string): number {
  const normalizedRole = role.toLowerCase();
  return DATASET_ROLE_HIERARCHY.findIndex((rolesAtLevel) =>
    rolesAtLevel.some(
      (roleAtLevel) => roleAtLevel.toLowerCase() === normalizedRole,
    ),
  );
}

// owner > contributor > annotator > consumer/restrictedConsumer
export function hasDatasetRole(
  roles: string[] | null,
  requiredRole: DatasetRoleName,
): boolean {
  if (!roles || roles.length === 0) return false;
  const requiredLevel = getRoleLevel(requiredRole);
  if (requiredLevel === -1) return false;

  return roles.some((role) => {
    const roleLevel = getRoleLevel(role);
    return roleLevel !== -1 && roleLevel <= requiredLevel;
  });
}
